export default __webpack_public_path__ + "static/media/banner-02.b9a2f3d8.jpeg";